export default {
  HEADER_FONT: "tw-p-0 tw-border-b-[1px] tw-border-b-gray-10",
  ROW_FONT: "tw-p-0 tw-px-0 tw-py-[10px] tw-border-hidden tw-align-middle",
  FONT_STYLE: "tw-leading-[20px] tw-text-[14px] tw-font-semibold tw-text-gray-75",
};
